<template>
  <div>
    <v-simple-table fixed-header class="performacne-mkt-table" id="style-2">
      <template v-slot:default>
        <thead>
          <tr>
            <th>Marketer</th>
            <th>Fanpage</th>
            <th>Master_id</th>
            <th>Content_id</th>
            <th>Số hội thoại</th>
            <th style="width:100px">Số điện thoại mang về</th>
            <th style="width:100px">Tỷ lệ chuyển đổi ( CTS/HT )</th>
            <th>Đơn khởi tạo</th>
            <th style="width:100px">TLC <br>( Đơn KT /HT)</th>
            <th style="width:100px">TLC <br>( Đơn KT /cts)</th>
            <th>DT khởi tạo</th>
            <th>DT thành công</th>
          </tr>
        </thead>
        <tbody class="fixed-sum">
          <tr v-if="totalReport">
            <td colspan="4" class="text-center focusText">TỔNG</td>
            <td class="focusText">
              {{
                totalReport.total_conversation_count
                  ? totalReport.total_conversation_count
                  : "0"
              }}
            </td>
            <td>
              {{
                totalReport.total_phone_conversion
                  ? totalReport.total_phone_conversion
                  : "0"
              }}
            </td>
            <td>
              <span v-if="totalReport.total_cts_ht"
                >{{ totalReport.total_cts_ht }} %</span
              >
            </td>
            <td>
              {{
                totalReport.total_init_order
                  ? totalReport.total_init_order
                  : "0"
              }}
            </td>
            <td>
              <span v-if="totalReport.total_tlc_ht"
                >{{ totalReport.total_tlc_ht }} %</span
              >
            </td>
            <td>
              <span v-if="totalReport.total_tlc_cts"
                >{{ totalReport.total_tlc_cts }} %</span
              >
            </td>
            <td>
              {{
                totalReport.total_init_revenue
                  ? totalReport.total_init_revenue
                  : "0"
              }}
            </td>
            <td>
              {{
                totalReport.total_success_revenue
                  ? totalReport.total_success_revenue
                  : "0"
              }}
            </td>
          </tr>
        </tbody>
        <tbody
          v-for="(content, index) in dataReport"
          :key="'mkt-report' + index"
          class="bg-hover"
        >
          <tr
            v-for="(item, index) in content.items"
            :key="'mkt-report-sub' + index"
          >
            <td
              v-if="index === 0"
              :rowspan="content.items.length"
              class="focusText"
            >
              {{ content.marketer_name }}
            </td>
            <td class="focusText">
              {{ item.fanpage_id ? item.fanpage_id : "-" }}
            </td>
            <td class="focusText">
              {{ item.master_id ? item.master_id : "-" }}
            </td>
            <td class="focusText">
              {{ item.content_id ? item.content_id : "-" }}
            </td>
            <td class="focusText">
              {{
                item.conversation_count || item.conversation_count === 0
                  ? item.conversation_count
                  : "-"
              }}
            </td>
            <td>
              {{
                item.phone_conversion_count || item.phone_conversion_count === 0
                  ? item.phone_conversion_count
                  : "-"
              }}
            </td>
            <td>
              {{ item.cts_ht || item.cts_ht === 0 ? item.cts_ht + "%" : "-" }}
            </td>
            <td>
              {{
                item.init_order_count || item.init_order_count === 0
                  ? item.init_order_count
                  : "-"
              }}
            </td>
            <td>
              {{ item.tlc_ht || item.tlc_ht === 0 ? item.tlc_ht + "%" : "-" }}
            </td>
            <td>
              {{
                item.tlc_cts || item.tlc_cts === 0 ? item.tlc_cts + "%" : "-"
              }}
            </td>
            <td>
              {{
                item.init_revenue || item.init_revenue === 0
                  ? item.init_revenue
                  : "-"
              }}
            </td>
            <td>
              {{
                item.success_revenue || item.success_revenue === 0
                  ? item.success_revenue
                  : "-"
              }}
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr v-if="dataReport.length === 0">
            <td colspan="12" class="text-center">Không có dữ liệu</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div v-if="totalPage" class="d-flex justify-end mx-3 my-2">
      <div style="width: fit-content">
        <v-pagination
          v-model="value"
          :length="totalPage"
          :total-visible="totalPage < 7 ? totalPage : 7"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    totalReport: {
      type: Object,
      default: () => {},
    },
    dataReport: {
      type: Array,
      default: () => [],
    },
    totalPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      value: 1,
    };
  },
  watch: {
    value(val) {
      this.$emit("changePage", val);
    },
  },
  methods: {},
};
</script>
<style lang="scss">
.performacne-mkt-table {
  .v-data-table__wrapper {
    max-height: 84vh !important;
  }
}
@media screen and (max-width: 1440px) {
  .performacne-mkt-table {
    .v-data-table__wrapper {
      max-height: 80vh !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.bg-hover {
  &:hover {
    td {
      background: #eeeeee;
    }
  }
}
.performacne-mkt-table {
  th {
    background: #d4d5ff !important;
    border-right: 1px solid #fff !important;
    color: #5d62d1 !important;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 220% */
  }
  td {
    border: 1px solid rgba(0, 0, 0, 0.06) !important;
    background: #fff;
    color: #666 !important;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    height: 47px;
    line-height: normal;
    &.focusText {
      color: #454545 !important;
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
  tr {
    &:hover {
      td {
        background: #eeeeee;
      }
    }
  }
  tbody {
    &.fixed-sum {
      td {
        position: sticky;
        top: 48px;
        z-index: 2;
      }
    }
  }
}
</style>